export default {
  // 开发
  develop: 'http://www.youkehulian.cn/mass/',
  // 正式
  product: 'https://www.youkehulian.com/mass/',
  // product: 'http://116.62.57.92:8080/',
  // 邓敏
  // local: 'http://192.168.153.98:8080/',
  // 线上测试

  local: 'http://192.168.1.6:8899/',
  // local: 'http://www.youkehulian.cn/mass/',

  //local: 'http://106.15.89.121:8080/',
  // 阿里对象存储
  alioss: 'http://106.14.219.98:3000/'
}
